import Enum from './enum'

class FixDateChoice extends Enum
{
  constructor(value) {
    super(value);
  }
}

FixDateChoice.init({
  EMPTY: 'None',
  VARIANT1: 'ActiveRetend',
  VARIANT2: 'EstimatedContractDate',
  VARIANT3: 'EstimatedDeliveryDate',
  VARIANT4: 'EstimatedPaymentDate',
}, {
    EMPTY : 'fix-date-choice.none' ,
  VARIANT1: 'fix-date-choice.active-retend' ,
  VARIANT2: 'fix-date-choice.estimated-contract-date',
  VARIANT3: 'fix-date-choice.estimated-delivery-date',
  VARIANT4: 'fix-date-choice.estimated-payment-date',
}, {
  mandatory: ['VARIANT1', 'VARIANT2', 'VARIANT3', 'VARIANT4']
});

export default FixDateChoice;
